export default __webpack_public_path__ + "img/pin_icons/door_w.png";